import { Home, Inbox, ListChecks, type LucideIcon } from 'lucide-vue-next';
import type { RouteLocationRaw } from 'vue-router';

export interface NavItem {
  /** Where it goes before an organization is chosen (the router picks one). */
  to: string;
  /** The page in the current organization. */
  route: 'org' | 'inbox' | 'my-work';
  label: string;
  icon: LucideIcon;
  /** Items for features that aren't built yet render disabled. */
  enabled: boolean;
  /** Shows the unread notification count. */
  counts?: boolean;
}

/** Primary destinations, shared by the sidebar, drawer and phone tab bar. Home is the current org's projects. */
export const PRIMARY_NAV: NavItem[] = [
  { to: '/', route: 'org', label: 'Home', icon: Home, enabled: true },
  { to: '/inbox', route: 'inbox', label: 'Inbox', icon: Inbox, enabled: true, counts: true },
  { to: '/my-work', route: 'my-work', label: 'My work', icon: ListChecks, enabled: true },
];

/** The item's page in `org`, so the current page shows as active. */
export function navTarget(item: NavItem, org: string | null): RouteLocationRaw {
  return org ? { name: item.route, params: { org } } : item.to;
}

/** "3 unread", for screen readers (the badge shows just the number). */
export function unreadLabel(count: number): string {
  return `${count > 99 ? '99+' : count} unread`;
}
